import styled, { keyframes } from 'styled-components';

import { PercentProps } from './interface';

const BgAnimation = keyframes`  
  0% {
  background-position: 0% 50%;
  }
  50% {
    background-position: 100% 50%;
  }
  100% {
    background-position: 0% 50%;
}
`;

export const Container = styled.div`
  float: left;
  width: 100%;
  position: fixed;
  height: 100%;
  z-index: 4000;

  background: ${({ theme }) =>
    `linear-gradient(to right,rgba(255,255,255,0.1),rgba(255,255,255,0.2))`};
  background-size: 200% 100%;

  animation-name: ${BgAnimation};
  animation-duration: 10s;
  animation-iteration-count: infinite;
  animation-direction: ease;
  padding: 2rem;

  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;

  @media (max-width: 1024px) {
    background: ${({ theme }) => '#f0f'};
    background-size: 100% 100%;
  }
`;

const PercentAnimation = keyframes`  
  from {
    background-position-x: 0;
  }
  to {
    background-position-x: -80px;
  }
`;

export const Bar = styled.div`
  float: left;
  height: 4rem;
  width: 100%;
  max-width: 60rem;
  border-radius: 1rem;

  box-shadow: ${({ theme }) => `1px solid ${theme.colors.BORDER}`};

  box-shadow: ${({ theme }) => `1px 5px 5px ${theme.colors.SHADOW}`};

  background-size: 120%;
  background-color: ${({ theme }) => theme.colors.TEXT1};
  background-image: ${({ theme }) => ` repeating-linear-gradient(
    45deg,
    transparent,
    transparent 40px,
    ${theme.colors.LIGHT1} 40px,
    ${theme.colors.LIGHT2} 80px
  );`};

  animation-name: ${PercentAnimation};
  animation-duration: 2s;
  animation-iteration-count: infinite;
  animation-direction: linear;
  will-change: background-position;

  @media (max-width: 1024px) {
    height: 3rem;
  }
`;

export const Percent = styled.div<PercentProps>`
  float: left;
  min-width: 4rem;
  height: 4rem;
  width: ${({ percent }) => `${percent}%`};
  border-radius: 1rem;
  border: ${({ theme }) => `1px solid ${theme.colors.BORDER}`};
  box-shadow: ${({ theme }) => `1px 5px 5px ${theme.colors.SHADOW}`};
  background-color: ${({ theme }) => theme.colors.TEXT1};
  transition: all 0.5s ease;
  display: flex;
  align-items: flex-end;
  flex-direction: row;
  justify-content: flex-end;
  transition: all 1s ease;

  span {
    display: flex;
    flex-direction: column;
    float: right;
    align-items: center;
    margin: 0rem -2rem 0 0;
    transform: translateY(-3.5rem);

    i {
      background-color: ${({ theme }) => theme.colors.LIGHT1};
      color: ${({ theme }) => theme.colors.TEXT1};
      border-radius: 1rem;
      font-size: 1.2rem;
      padding: 1rem;
      float: left;
      margin: 0 0 -10px 0;
    }

    @media (max-width: 1024px) {
      transform: translateY(-2.5rem);
    }
  }

  @media (max-width: 1024px) {
    height: 3rem;
  }
`;

export const Information = styled.div`
  width: 100%;
  max-width: 60rem;
  display: flex;
  align-items: center;
  justify-content: center;
  flex-direction: column;
  margin: 3rem 0 0 0;

  h1 {
    font-size: 2.2rem;
  }

  p {
    background: ${({ theme }) => theme.colors.TEXT1};
    font-size: 1.4rem;
    margin: 0.5rem 0 0 0;
  }

  @media (max-width: 1024px) {
    h1 {
      font-size: 1.4rem;
      text-align: center;
    }
    p {
      font-size: 1rem;
      text-align: center;
    }
  }
`;

const WaveAnimation = keyframes`  
   2% {
        transform: translateX(1);
    }

    25% {
        transform: translateX(-25%);
    }

    50% {
        transform: translateX(-50%);
    }

    75% {
        transform: translateX(-25%);
    }

    100% {
        transform: translateX(1);
    }
`;

export const Waves = styled.div`
  .wave {
    background: ${({ theme }) => theme.colors.LIGHT1};
    border-radius: 1000% 1000% 0 0;
    position: fixed;
    width: 200%;
    height: 12em;
    animation: ${WaveAnimation} 10s -3s linear infinite;
    transform: translate3d(0, 0, 0);
    opacity: 0.8;
    bottom: 0;
    left: 0;
    z-index: -1;
  }

  .wave:nth-of-type(2) {
    bottom: -1.25em;
    animation: ${WaveAnimation} 18s linear reverse infinite;
    opacity: 0.8;
  }

  .wave:nth-of-type(3) {
    bottom: -2.5em;
    animation: ${WaveAnimation} 20s -1s reverse infinite;
    opacity: 0.9;
  }
`;
